export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_04.17351d77.png";